<kendo-chip [label]="$name()" [themeColor]="$themeColor()" [size]="$size()" />
